// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'
import $ from "jquery"
// import Vue from 'vue'
import App from './App'
import router from './router'
import util from './assets/js/util.js'
import customExportTable from './assets/js/customExportTable'
import axios from './axios/request'
import store from './vuex/store'

// import cli from  './assets/js/vue-clipboard.min.js'
// Vue.use(cli)
// 从pass项目拷贝的工具

import '@/assets/css/common.css'
// 引入element
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)
import VueCropper from 'vue-cropper'

//引入vue-scrolll滚动条优化插件
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
Vue.use(vuescroll);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.config.devtools = true
// import VConsole from 'vconsole' //import vconsole
// let vConsole = new VConsole() // 初始化 

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview,{
  fullscreenEl: false
})
Vue.use(preview)

import wordExport from '@/assets/js/jquery.wordexport.js'

Vue.use(wordExport)

// 引入iview
// import iView from 'iview'
import 'iview/dist/styles/iview.css'
// Vue.use(iView)


Vue.use(VueCropper)
Vue.config.productionTip = false
Vue.use(util)

Vue.prototype.$ = $;
Vue.prototype.$axios = axios;

Vue.use(customExportTable)

// import 'amfe-flexible/index.js' // 用于rem计算

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

//适配双双header 给notify组件添加offset
const notify = Vue.prototype.$notify
Vue.prototype.$notify = function newNotify(option){
  return notify(Object.assign(option,{offset:100}));
}

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js